<script lang="ts">
  import BasicLink from './BasicLink.svelte'
  import DropdownMenu from './DropdownMenu.svelte'
</script>

<DropdownMenu selected="Privacy policy" />

<div class="wrapper">
  <h2>Progetto INTERREG GOVERNATIVa - APP Mobilità</h2>
  <h1>
    INFORMATIVA PER IL TRATTAMENTO DEI DATI PERSONALI AI SENSI DELL’ ART. 13 DEL REGOLAMENTO EUROPEO
    N. 679/2016
  </h1>

  <p>
    La informiamo che eventuali dati personali da Lei forniti tramite la Sua partecipazione al
    sondaggio (per la quale La ringraziamo molto) verranno trattati nel rispetto della normativa
    sulla protezione dei dati personali (D. Lgs. 196/03 e ss.mm. e Regolamento Europeo n. 679/2016,
    di seguito anche GDPR) ed in conformità ai principi dettati dalla legge.
    <br />
    Si precisa che si intende per:
    <br />
    <br />
    i) «dato personale»: qualsiasi informazione riguardante una persona fisica identificata o identificabile
    («interessato»);
    <br />
    ii) «trattamento»: qualsiasi operazione o insieme di operazioni, compiute con o senza l&#39;ausilio
    di processi automatizzati e applicate a dati personali o insiemi di dati personali, come la raccolta,
    la registrazione, l&#39;organizzazione, la strutturazione, la conservazione, l&#39;adattamento o
    la modifica, l&#39;estrazione, la consultazione, l&#39;uso, la comunicazione mediante trasmissione,
    diffusione o qualsiasi altra forma di messa a disposizione, il raffronto o l&#39;interconnessione,
    la limitazione, la cancellazione o la distruzione;
  </p>

  <h3>1. IDENTITA&#39; E DATI DI CONTATTO DEL TITOLARE DEL TRATTAMENTO</h3>

  <p>
    Il Comune di Varese è il Titolare del trattamento dei dati, con sede in Via Luigi Sacco, 5,
    21100 Varese VA. Potrà essere contattato ai seguenti riferimenti:
    <br />
    - Telefono: 0332 255232 - 734 - 759 (Area IX – Ufficio Pianificazione della Mobilità)
    <br />
    - E-mail: <a href="mailto:privacy@comune.varese.it">privacy@comune.varese.it</a>
    <br />
    - Indirizzo PEC:
    <a href="mailto:protocollo@comune.varese.legalmail.it">protocollo@comune.varese.legalmail.it</a>
  </p>

  <h3>2. IDENTITA&#39; E DATI DI CONTATTO DEL RESPONSABILE DELLA PROTEZIONE DEI DATI</h3>
  <p>
    Il Comune di Varese ha provveduto a nominare il proprio Responsabile della protezione dei dati.
    Qualsiasi richiesta in merito al trattamento dei dati personali conferiti e all’esercizio dei
    diritti dovrà essere indirizzata al Responsabile della protezione dei dati (RPD o DPO) al
    seguente indirizzo: <a href="mailto:privacy@comune.varese.it">privacy@comune.varese.it</a>
  </p>

  <h3>3. FINALITA’ DEL TRATTAMENTO E BASE GIURIDICA</h3>

  <p>
    Nel rispetto dei principi di liceità, correttezza, trasparenza, adeguatezza, pertinenza e
    necessità di cui all’art. 5, paragrafo 1 del GDPR il Titolare del trattamento provvederà al
    trattamento dei dati personali forniti dall’interessato, con l’ausilio di mezzi elettronici, per
    il perseguimento delle seguenti finalità:
    <br />
    <br />
    i) condurre indagini su una determinata community territoriale relative al rilevamento statistico
    di abitudini legate alla mobilità (es. tragitto casa-lavoro e mezzo scelto);
    <br />
    ii) creare modelli di studio di comportamento e la conseguente ottimizzazione delle risorse, attuando
    strategie orientate alla mobilità sostenibile e interventi mirati al suo miglioramento;
    <br />
    iii) compiere attività di ricerca statistica e scientifica;
    <br />
    iv) sondare la soddisfazione degli utenti sulle tematiche della mobilità;
    <br />
    v) promuovere sensibilità verso queste tematiche attraverso pubblicazioni, dibattiti ed eventi;
    <br />
    <br />
    Il trattamento dei dati rientra nelle condizioni di cui all’art. 6 par. 1 lett. e) del GDPR.
  </p>

  <h3>4. CATEGORIE DI DATI TRATTATI E LORO CONFERIMENTO</h3>
  <p>
    Il sondaggio è generalmente condotto in forma anonima e riservata, ma il software utilizzato
    registra le informazioni sull’account con il quale è stato compilato il sondaggio e l’IP
    impiegato: ciò potrebbe comportare un trattamento di alcuni dati associabili per via indiretta
    alla persona. Si precisa che i dati relativi all’account e all’IP sono accessibili unicamente
    dall’amministratore di sistema, che ha il divieto di comunicare tali dati al personale che
    riceverà le risposte al sondaggio; pertanto, sono e rimangono separati dai restanti dati oggetto
    del sondaggio, trattati da altro specifico personale autorizzato. Grazie a detta separazione di
    dati, le risposte sono dunque da intendersi gestite in forma anonima dai dipendenti del Comune
    incaricati dell’attività di elaborazione. Si precisa che, in alcuni casi, per la particolarità
    delle risposte, anche se i dati sono ricevuti in forma anonima, potrebbe avvenire un eventuale
    riconoscimento indiretto da parte del personale del Comune di Varese, che potrebbe ricondurre le
    risposte alla singola persona. Per nessuno motivo i dati saranno trattati da questi ultimi
    tenendo in considerazione questa eventuale identificazione, che è estranea alle finalità del
    sondaggio e pertanto non verrà trattata in quanto non autorizzato.
    <br />
    Il conferimento di detti dati è facoltativo e la partecipazione al sondaggio è di natura volontaria;
    tuttavia, il conferimento di questi dati è di fondamentale importanza per permettere al Comune di
    Varese di progettare interventi atti a migliorare la mobilità sul territorio. Se non partecipa non
    potrà dunque contribuire a tale finalità attraverso il rilascio della Sua opinione.
    <br />
    Potrebbero essere utilizzati dal software anche cookie di tipo tecnico. A tal riguardo si rimanda
    alla policy cookies.
  </p>

  <h3>DESTINATARI DEI DATI E TRASFERIMENTO DEI DATI FUORI UE</h3>
  <p>
    I dati potranno essere trattati da:
    <br />
    <br />
    i) dipendenti e collaboratori del Titolare del trattamento, nella loro qualità di autorizzati al
    trattamento;
    <br />
    ii) soggetti esterni che, ai soli fini della prestazione richiesta dal Titolare, potrebbero venire
    a conoscenza dei dati degli interessati e che pertanto sono debitamente nominati come Responsabili
    del trattamento a norma dell’art. 28 del Gdpr (si precisa a tal riguardo che una delle società esterne
    nominate svolgerà attività di amministratore di sistema);
    <br />
    iii) soggetti esterni, laddove la comunicazione degli stessi dati sia prevista da norme di legge
    o da richieste da parte di Autorità Pubbliche, o per la tutela di un diritto. In questo caso i soggetti
    esterni agiscono come autonomi titolari.
    <br />
    <br />
    Si precisa che:
    <br />
    <br />
    i) i dati saranno raccolti ed elaborati su database localizzati in territorio europeo. Il rapporto
    con il fornitore dell’infrastruttura, essendo localizzato in paesi extra-europei, è stato regolamentato
    tramite Clausole Contrattuali Standard;
    <br />
    ii) i dati privi di qualsivoglia riferimento identificativo diretto o indiretto potranno essere comunicati
    a terzi per finalità statistiche e di ricerca, ed esclusivamente in forma aggregata;
    <br />
    iii) i dati verranno diffusi in forma anonima e aggregata attraverso: pubblicazioni, comunicazioni
    istituzionali, statistiche e convegni scientifici.
  </p>

  <h3>PERIODO DI CONSERVAZIONE DEI DATI</h3>
  <p>
    I dati personali eventualmente trattati vengono conservati per il tempo strettamente necessario
    a conseguire gli scopi per cui sono stati raccolti di elaborare lo studio sulla mobilità
    condotto dal Comune, per un massimo di 12 mesi, periodo oltre il quale i dati verranno
    cancellati. I dati anonimi e aggregati saranno conservati a tempo indeterminato.
  </p>

  <h3>PROCESSO DECISIONALE AUTOMATIZZATO E PROFILAZIONE</h3>
  <p>
    Il Titolare non utilizza in alcun modo processi decisionali automatizzati, ivi compresa la
    profilazione.
  </p>

  <h3>I DIRITTI DELL’INTERESSATO</h3>
  <p>
    Ai sensi dell’art. 11 del GDPR, data l’impossibilità tecnica di ricondurre un singolo
    questionario al soggetto che lo ha compilato, non sarà possibile garantire i Suoi diritti
    all’accesso, rettifica, cancellazione, limitazione del trattamento e portabilità dei dati.
    <br />
    Laddove tale identificazione sia possibile, all&#39;interessato vengono riconosciuti i diritti di
    cui agli artt. 15 e ss del Regolamento UE 679/2016. In particolare, l’interessato, nei modi e nei
    limiti previsti dalla normativa, ha il diritto di:
    <br />
    <br />
    i) ottenere, in qualunque momento, la conferma che sia o meno in corso un trattamento di dati personali
    che lo riguardano;
    <br />
    ii) accedere ai propri dati personali per conoscere: la finalità del trattamento, la categoria di
    dati trattati, i destinatari o le categorie di destinatari cui i dati sono o saranno comunicati,
    il periodo di conservazione degli stessi o i criteri utilizzati per determinare tale periodo;
    <br />
    iii) richiedere la rettifica e, nei casi previsti dalla normativa, la cancellazione o, ancora, la
    limitazione del trattamento;
    <br />
    iv) opporsi, nei casi previsti e per motivi legittimi, al loro trattamento;
    <br />
    v) di revocare il consenso eventualmente prestato;
    <br />
    <br />
    Per esercitare tali diritti potrà rivolgersi al Titolare o al Responsabile della Protezione dei dati,
    ai riferimenti indicati in epigrafe.
    <br />
    Potrà altresì:
    <br />
    <br />
    vi) proporre reclamo all’Autorità Garante per la protezione dei dati o ricorso innanzi all&#39;autorità
    giudiziaria per la tutela dei propri diritti.
    <br />
    <br />
    Per richiedere maggiori informazioni e/o aggiornamenti può inoltrare le Sue richieste ai contatti
    del Titolare o del RPD sopra indicati.
  </p>
</div>

<style>
  .wrapper {
    color: white;
    margin-top: 55px;
    padding: 1rem 2rem;
    font-size: 0.9rem;
  }
</style>
